import React from 'react';
import SmallHeading from './../components/SmallHeading';
import Heading from './../components/Heading';
import DetailsHeading from './../components/DetailsHeading';
import PricingCard from './../components/PricingCard';

const PricingSection = () => {
    return (
    <section id="pricing">
        <SmallHeading name="Pricing Plans Preview" tstyle="text-center my-1 mt-10"/>
        <Heading name="Flexible Pricing Plans" tstyle="text-center my-1"/>
        <div className="mt-10">
            <DetailsHeading 
                name="Explore our flexible and scalable legal service plans tailored to meet your specific needs."
                tstyle="text-center my-1"
            />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-10 mx-10">
           <PricingCard
            heading="Monthly Subscription"
            price="1,000"
            includes="Includes 25 hours per month"
            rate="Approximately $40/hour"
            duration="month"
            additionalHoursRate="$35/hour"
          />
          <PricingCard
            heading="Quarterly Subscription"
            price="2,250"
            includes="Includes 75 hours per quarter"
            rate="Approximately $30/hour"
            duration="quater"
            additionalHoursRate="$30/hour"
          />
          <PricingCard
            heading="Annual Subscription"
            price="6,000"
            includes="Includes 300 hours per year"
            rate="Approximately $20/hour"
            duration="year"
            additionalHoursRate="$25/hour"
          />
          <PricingCard
            heading="FTE Subscription"
            price="15,000"
            includes="Includes a full time dedicated associate level resource"
            rate=""
            duration="year"
            additionalHoursRate="$20/hour"
          />

        </div>
           
    </section>
    );
};

export default PricingSection;
